interface GroupedOption {
  group?: string
  name: string
  value: string
}

const sortByGroupingThenName = (a: GroupedOption, b: GroupedOption) => {
  const aKey = `${a.group ?? ''}:${a.name}`
  const bKey = `${b.group ?? ''}:${b.name}`

  if (aKey > bKey) return 1
  if (aKey < bKey) return -1

  return 0
}

export { sortByGroupingThenName }
export type { GroupedOption }
